import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import { PayloadAction } from "@reduxjs/toolkit";
import {
    failureGetScheduledClasses,
    getScheduledClasses,
    ScheduledClassesFilter,
    successGetScheduledClasses,
} from "./ScheduledClassesSlice";

// API call to fetch scheduled classes with filters
const GetScheduledClassesApi = (filters: ScheduledClassesFilter) => {
    const params = new URLSearchParams();
    if (filters.tutor_id !== undefined) params.append("tutor_id", filters.tutor_id.toString());
    if (filters.status_filter !== undefined) params.append("status_filter", filters.status_filter.toString());
    if (filters.date_filter) params.append("date_filter", filters.date_filter);
    if (filters.question_type_id !== undefined) params.append("question_type_id", filters.question_type_id.toString());
    if (filters.subject_id !== undefined) params.append("subject_id", filters.subject_id.toString());
    if (filters.limit !== undefined) params.append("limit", filters.limit.toString());
    if (filters.page !== undefined) params.append("page", filters.page.toString());
    if (filters.order_by) params.append("order_by", filters.order_by);
    if (filters.class_id !== undefined) params.append("class_id", filters.class_id.toString());
    if (filters.search_string) params.append("search_string", filters.search_string);

    return api.get(`/api/schedule-class/list?${params.toString()}`);
};

// Saga to handle fetching scheduled classes
export function* ScheduledClassesCall(action: PayloadAction<ScheduledClassesFilter>) {
    try {
        const response: AxiosResponse = yield call(GetScheduledClassesApi, action.payload);
        yield put(successGetScheduledClasses(response.data));
    } catch (error: any) {
        yield put(failureGetScheduledClasses(error.response?.data || error.message));
    }
}
